import React from 'react'
import classnames from 'classnames'
import Card from '@material-ui/core/Card'
import { withStyles } from '@material-ui/core/styles'
import { Row, Col } from 'react-flexbox-grid'
import Columns from '../../styles/columns'
import CardStyles from '../../styles/cards'
import TitledLabel from '../../controls/TitledLabel'
import { localize } from '../../util/Localizer'
import RBButton from '../../controls/RBButton'
import GenericModal from '../../widgets/common/GenericModal'

class DentalClaimExpenseLine extends React.Component {
  constructor () {
    super()
    this.state = { showGenericModal: false }
  }

  render () {
    let { expenseDetail, hasCOB, classes = {} } = { ...this.props }
    return (
      <Card className={ classnames(classes.summaryCard, classes.baseCard) }>
        {this.state.showGenericModal
          ? <GenericModal
            open={this.state.showGenericModal}
            handleOk={() => {
              this.props.onDelete(this.props.index)
              this.setState({ showGenericModal: false })
            }}
            handleClose={() => {
              this.setState({ showGenericModal: false })
            }}
            showOk
            OkButtonText={localize('yesText')}
            CancelButtonText={localize('noText')}
            modal
            message={localize('pages.SubmitAClaim.DeleteWarning')}
          /> : null}
        <Row>
          <Col xs={12} sm={12} md={8} lg={8}>
            <Row>
              <Col {...Columns.max4}>
                <TitledLabel title='pages.SubmitAClaim.Expenses.ServiceDate' format='date' value={expenseDetail.ServiceDate} />
              </Col>
              <Col {...Columns.max4}>
                <TitledLabel title='pages.SubmitAClaim.Expenses.Dental.DentistsFee' format='currency' value={expenseDetail.DentalInfo.ProcedureFees} />
              </Col>
              <Col {...Columns.max4}>
                <TitledLabel title='pages.SubmitAClaim.Expenses.Dental.LabCharge' format='currency' value={expenseDetail.DentalInfo.LaboratoryFees} />
              </Col>
              <Col {...Columns.max4}>
                <TitledLabel title='pages.SubmitAClaim.Expenses.TotalReceiptAmount' format='currency' value={expenseDetail.DentalInfo.TotalCharges} />
              </Col>
              <Col {...Columns.max4}>
                <TitledLabel title='pages.SubmitAClaim.Expenses.Dental.ProcedureCode' format='text' value={expenseDetail.DentalInfo.ProcedureCode} />
              </Col>
              {expenseDetail.DentalInfo.ToothCode &&
                <Col {...Columns.max4}>
                  <TitledLabel title='pages.SubmitAClaim.Expenses.Dental.ToothCode' format='text' value={expenseDetail.DentalInfo.ToothCode || 'N/A'} />
                </Col>
              }
              {expenseDetail.DentalInfo.ToothSurface &&
              <Col {...Columns.max4}>
                <TitledLabel title='pages.SubmitAClaim.Expenses.Dental.ToothSurfaces' format='text' value={expenseDetail.DentalInfo.ToothSurface || 'N/A'} />
              </Col>}
              {hasCOB &&
              <Col {...Columns.max4}>
                <TitledLabel title='pages.SubmitAClaim.Expenses.AmountReceivedFromAllOtherInsurance' format='currency' value={expenseDetail.COBField.COBAmount} />
              </Col>
              }
            </Row>
          </Col>
          <Col xs={12} sm={12} md={4} lg={4}>
            <Row end='lg' middle='xs'>
              <Col xs={12}>
                <RBButton variant='outlined' label={localize('pages.SubmitAClaim.Expenses.DeleteButton')} onClick={() => this.setState({ showGenericModal: true })} className='submitNavButton' styles={{ margin: '0px 5px' }} />
                <RBButton variant='outlined' label={localize('pages.SubmitAClaim.Expenses.EditButton')} onClick={() => this.props.onEdit(this.props.index)} className='submitNavButton' styles={{ margin: '0px 5px' }}/>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
    )
  }
}

const styles = {
  ...CardStyles
}

export default withStyles(styles)(DentalClaimExpenseLine)



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/DentalClaimExpenseLine.js